// extracted by mini-css-extract-plugin
export default {"container":"smallbox_container__CYy+R","iconWrapper":"smallbox_iconWrapper__v6afo","text":"smallbox_text__z0UrZ","desc":"smallbox_desc__zJcaS"};